import * as React from 'react';
import ResetPassword from '../ResetPassword';

class SetPassword extends React.Component {
  public render() {
    return (
      <ResetPassword
        {...this.props}
        title={'Créez Votre Mot de Passe'}
        message={'Your password has been set, please login to access your account.'}
      />
    );
  }
}

export default SetPassword;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/SetPassword/index.tsx